<template>
  <b-modal
    @show="onShow"
    dialog-class="md_modal_dialog_full"
    modal-class="md_modal_full"
    content-class="md_modal_content_full"
    header-class="dlg_header no_border"
    :visible="visible"
    hide-footer
    hide-backdrop
    no-close-on-backdrop
    @hide="onCancel"
  >
    <template #modal-header="{close}">
      <div class="popup_title" style="flex: 1; text-align: center;">{{ $t('more.address_search') }}</div>
      <b-button class="dlg_close_btn" variant="white" @click="onCancel">
        <b-img :src="require('../../../assets/image/ic_close2.png')" style="height: 1em; margin-left: 7px; margin-right: 3px; "/>
      </b-button>
    </template>
    <div class="full">
     <VueDaumPostcode @complete="onComplete" />
    </div>
  </b-modal>
</template>

<script>

import { VueDaumPostcode } from 'vue-daum-postcode'

export default {
  name: "DaumPostPopup",
    components: {
    VueDaumPostcode, // export VueDaumPostcode is component
  },
  props:{
    visible:{
      type:Boolean,
      default:false,
    },
  },
  data() {
    return {
      showPointPopup: false,
      showProfilePopup: false,
    }
  },
  mounted() {

  },
  methods:{
    onShow() {

    },
    onCancel()  {
      this.$emit('update:visible', false);
    },
    onAddressSearch (jibun, road, searchAddr) {
      //TODO:
      this.myinfo.tmpAddress = jibun;
      this.myinfo.tmpRoadAddress = road;
      this.myinfo.tmpSearchAddress = searchAddr;
      this.$emit('update:visible', false);
      this.$emit('onConfirm');
    },
    onComplete(data) {
      console.log(data);
      var jibun = data.jibunAddress;
      if (jibun == "") {
          jibun = data.autoJibunAddress;
      }
      this.myinfo.tmpAddress = jibun;
      this.myinfo.tmpRoadAddress =  data.roadAddress;
      this.myinfo.tmpSearchAddress = data.address;
      this.$emit('update:visible', false);
      this.$emit('onConfirm');
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/_vars.scss";
.map {
  background-color: #bbe2c6;
  height: 100%;
  width: 100%;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/controls/popup/DaumPostPopup.vue